import React from 'react';
function Grid2({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M7 3H3V7H7V3Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 10H3V14H7V10Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 17H3V21H7V17Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 3H10V7H14V3Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 10H10V14H14V10Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 17H10V21H14V17Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 3H17V7H21V3Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 10H17V14H21V10Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 17H17V21H21V17Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default Grid2;
